
import { Component, Vue } from 'vue-property-decorator';

import { links } from '@/configs/links';

@Component
export default class RampHeaderV extends Vue {
    links = links;

    changeLang() {
        this.$i18n.locale = this.$i18n.locale === 'en' ? 'fr' : 'en';

        this.$router.replace({ query: { lang: this.$i18n.locale } });
        document.title = this.$i18n.t('page.title') as string;
        document.documentElement.lang = this.$i18n.locale;
    }

    scrollToFeatures() {
        const el = document.querySelector('div#features') as HTMLElement;

        window.scrollTo(0, el.offsetTop);
    }
}
